import { toaster } from 'uikit/Toaster'
import { useQuery } from '@tanstack/react-query'
import { api } from 'api'

export const useSettingsFetch = () => {
  const response = useQuery({
    queryKey: ['paymentsIntervalSettings'],
    queryFn: () => api.payments.fetchSettings(),
    enabled: false, // Запрос выполняется только по требованию
  })

  if (response.isError) {
    toaster.create({
      title: 'Ошибка',
      description: 'Не удалось получить настройки интервала платежей',
      type: 'error',
    })
  }

  return response
}
